import { TwoColumnLayout } from 'layouts';
import type { EntityOptions, Media, VideoContentObject } from 'models';
import { Col, Row } from 'ui';
import { NetworkShare } from 'features/network';
import { DescriptionCard, DetailsCard, WatchVideo } from '../../components';

type P = {
  fullData?: Media;
  getPathToEntityDetail: (id: string, options: EntityOptions) => string;
  videoContentObject: VideoContentObject;
};

const VideoPublishContent = ({ fullData, getPathToEntityDetail, videoContentObject }: P) => {
  const path = getPathToEntityDetail(videoContentObject.video.id, { entityType: 'video' });

  return (
    <TwoColumnLayout
      left={
        <Row>
          {fullData?.alts?.stream?.status === 'active' ? (
            <Col span={24}>
              <WatchVideo videoPath={fullData.alts.stream.path} />
            </Col>
          ) : null}

          <Col span={24}>
            <DescriptionCard videoContentObject={videoContentObject} />
          </Col>
        </Row>
      }
      right={
        <Row>
          <Col span={24}>
            <NetworkShare entityName={videoContentObject.video.name} path={path} />
          </Col>
          <Col span={24}>
            <DetailsCard organization={videoContentObject.organization} />
          </Col>
        </Row>
      }
    />
  );
};

export default VideoPublishContent;
